import { Text, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box, FlatList } from 'native-base';
import React from 'react';
import { StyleSheet } from 'react-native';

import { InfoItem, InfoItemProps } from '../InfoItem';

interface PlanDetailsProps {
  data: InfoItemProps[];
}

const style = StyleSheet.create({
  columnWrapper: {
    flex: 1,
    justifyContent: 'space-between',
  },
  list: {
    rowGap: 16,
  },
});

export const PlanDetails: React.FC<PlanDetailsProps> = ({ data }) => {
  const numColumns = useBreakpointValue({ base: 1, sm: 4 });
  return (
    <VStack
      space={Spacing['inline.xxxs']}
      bg={'background'}
      borderRadius={BoxRadius.sm}
      padding={Spacing['inline.xxxs']}>
      <Text variant="semibold" fontSize={Typography['fontsize.md']} color="neutral.dark">
        Dados do plano
      </Text>
      <Box bg={'neutral.lightest'} h={0.8} />
      <FlatList
        key={numColumns}
        data={data}
        numColumns={numColumns}
        style={style.list}
        showsVerticalScrollIndicator={false}
        keyExtractor={(item, index) => `${item.label}-${index}`}
        {...(numColumns !== 1 && { columnWrapperStyle: style.columnWrapper })}
        renderItem={({ item, index }) => {
          const isLastOfLine = (index + 1) % numColumns === 0;

          return (
            <Box {...(!isLastOfLine && { flex: 1 })} minW={'90px'}>
              <InfoItem {...item} />
            </Box>
          );
        }}
      />
    </VStack>
  );
};
